import { CircularProgress } from "@material-ui/core";
import { IframeDialog } from "app/Core/Components/IframeDialog/IframeDialog";
import clsx from "clsx";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const MensagemRSS = (props) => {

    const { item, classes } = props;
    const [data, setData] = useState(null);
    const settings = useSelector(({ auth }) => auth.user.data.settings);

    useEffect(() => {
        if (_.isNull(data)) {
            getDadosRSS();
        }
    }, []);

    function getDadosRSS() {
        let ARota = `${item.interacao}&sistema=${settings.tipo}`;
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        fetch(ARota, {
            method: "get",
            headers: myHeaders,
        })
            .then(resp => {
                resp.json().then(response => {
                    if (!_.isUndefined(response.error)) {
                        setData([{ "titulo": "Erro ao recuperar conteúdo." }]);
                    }
                    else {
                        setData(response);
                    }
                });
            })
            .catch(error => {
                setData([{ "titulo": "Erro ao recuperar conteúdo." }]);
            });
    }

    return (
        <React.Fragment>
            {!_.isNull(data) ?
                <React.Fragment>
                    {data.map(item => (
                        <Mensagem
                            id={item.id}
                            classes={classes}
                        >
                            {!_.isUndefined(item.url) ?
                                <IframeDialog
                                    url={item.url}
                                >
                                    <a component="button" className="block mt-4">
                                        {item.titulo}
                                    </a>
                                </IframeDialog>
                                :
                                <React.Fragment>
                                    {item.titulo}
                                </React.Fragment>
                            }
                        </Mensagem>
                    ))}
                </React.Fragment>
                :
                <Mensagem
                    id={"loading"}
                    classes={classes}
                >
                    <CircularProgress size={"20px"} className="m-4" color="none" />
                </Mensagem>
            }
        </React.Fragment>
    )

}

const Mensagem = ({ children, id, classes }) => {
    return (
        <div
            key={id}
            className={clsx(classes.messageRow, "flex flex-col flex-no-grow flex-no-shrink items-start justify-end relative pb-4 contact")}
        >
            <div
                className="bubble flex flex-col min-h-48 min-w-88 relative max-w-full justify-between"
            >
                <div className={clsx("leading-tight whitespace-pre-wrap mx-12 my-4")}>
                    {children}
                </div>
            </div>
        </div>
    );
}